import { IEditRestaurantState } from './editRestaurantContext';
import { TAdditionalApplications } from 'types';

export enum EditRestaurantActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	CHANGE_NAME = 'CHANGE_NAME',
	CHANGE_SHORT_NAME = 'CHANGE_SHORT_NAME',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_CLIENT_TYPE = 'SET_CLIENT_TYPE',
	SET_FETCHED_COUNTRIES = 'SET_FETCHED_COUNTRIES',
	SET_ID_COUNTRY = 'SET_ID_COUNTRY',
	SET_FETCHED_CITIES = 'SET_FETCHED_CITIES',
	SET_ID_CITY = 'SET_ID_CITY',
	CHANGE_ADDRESS = 'CHANGE_ADDRESS',
	SET_FETCHED_CURRENCIES = 'SET_FETCHED_CURRENCIES',
	SET_CURRENCY_SYMBOL = 'SET_CURRENCY_SYMBOL',
	CHANGE_MASTER_PHONE_NUMBER = 'CHANGE_MASTER_PHONE_NUMBER',
	CHANGE_EMAIL = 'CHANGE_EMAIL',
	CHANGE_CODE = 'CHANGE_CODE',
	SET_ADDITIONAL_APPLICATIONS = 'SET_ADDITIONAL_APPLICATIONS',
	CHANGE_VIVA_WALLET_ISV = 'CHANGE_VIVA_WALLET_ISV',
	CHANGE_SUPPLIER = 'CHANGE_SUPPLIER',
	TOGGLE_IS_OPEN_PRICE_PERCENT = 'TOGGLE_IS_OPEN_PRICE_PERCENT',
	CHANGE_OPEN_PRICE_PERCENT = 'CHANGE_OPEN_PRICE_PERCENT',
	CHANGE_PRICE_TYPE = 'CHANGE_PRICE_TYPE',
	TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE = 'TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE',
	CHANGE_LOYALTY = 'CHANGE_LOYALTY',
	TOGGLE_IS_USED_CUSTOMER_TIPS = 'TOGGLE_IS_USED_CUSTOMER_TIPS',
	SET_TIPS_0 = 'SET_TIPS_0',
	SET_TIPS_1 = 'SET_TIPS_1',
	SET_TIPS_2 = 'SET_TIPS_2',
	SET_TIPS_3 = 'SET_TIPS_3',
	SET_DEFAULT_TIPS = 'SET_DEFAULT_TIPS',
	SET_TIPS_COMMISSION_PERCENT = 'SET_TIPS_COMMISSION_PERCENT',
	SET_TIPS_COMMISSION_MAX_VALUE = 'SET_TIPS_COMMISSION_MAX_VALUE',
	TOGGLE_IS_CHARITY_ENABLED = 'TOGGLE_IS_CHARITY_ENABLED',
	CHANGE_CHARITY_NAME = 'CHANGE_CHARITY_NAME',
	SET_CHARITY_LOGO_FILE = 'SET_CHARITY_LOGO_FILE',
	SET_CHARITY_AMOUNT_0 = 'SET_CHARITY_AMOUNT_0',
	SET_CHARITY_AMOUNT_1 = 'SET_CHARITY_AMOUNT_1',
	SET_CHARITY_AMOUNT_2 = 'SET_CHARITY_AMOUNT_2',
	SET_CHARITY_AMOUNT_3 = 'SET_CHARITY_AMOUNT_3',
	SET_DEFAULT_CHARITY_AMOUNT_INDEX = 'SET_DEFAULT_CHARITY_AMOUNT_INDEX',
	TOGGLE_USE_KM_TARIFF = 'TOGGLE_USE_KM_TARIFF',
	TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS = 'TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS',
	CHANGE_BASE_MCC = 'CHANGE_BASE_MCC',
	ADD_MCC_CARD = 'ADD_MCC_CARD',
	DELETE_MCC_CARD = 'DELETE_MCC_CARD',
	CHANGE_MAIN_MCC_CARD_BRAND = 'CHANGE_MAIN_MCC_CARD_BRAND',
	CHANGE_MCC_CARD_BRAND = 'CHANGE_MCC_CARD_BRAND',
	CHANGE_MCC_CARD_MCC = 'CHANGE_MCC_CARD_MCC',
	CHANGE_MAIN_MCC_CARD_MCC = 'CHANGE_MAIN_MCC_CARD_MCC',
	TOGGLE_USE_CUSTOMER_MCC = 'TOGGLE_USE_CUSTOMER_MCC',
	CHANGE_DOWNLOAD_APP_ANDROID_URL = 'CHANGE_DOWNLOAD_APP_ANDROID_URL',
	CHANGE_DOWNLOAD_APP_IOS_URL = 'CHANGE_DOWNLOAD_APP_IOS_URL',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_ID_DEFAULT_LANGUAGE = 'SET_ID_DEFAULT_LANGUAGE',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	CHANGE_RESTRICTION_QR_VALUE = 'CHANGE_RESTRICTION_QR_VALUE',
	TOGGLE_USE_POS_PHOTOS = 'TOGGLE_USE_POS_PHOTOS',
	TOGGLE_STOP_LIST_JOB = 'TOGGLE_STOP_LIST_JOB',
	TOGGLE_USE_CUSTOMER_STOP_LIST_SYNC_INTERVAL = 'TOGGLE_USE_CUSTOMER_STOP_LIST_SYNC_INTERVAL',
	CHANGE_STOP_LIST_SYNC_INTERVAL_MINUTES = 'CHANGE_STOP_LIST_SYNC_INTERVAL_MINUTES',
	TOGGLE_UPDATE_OF_THE_LAUNCHER = 'TOGGLE_UPDATE_OF_THE_LAUNCHER',
	CHANGE_CARD_ACCEPTOR_ID = 'CHANGE_CARD_ACCEPTOR_ID',
	CHANGE_CARD_ACCEPTOR_NAME = 'CHANGE_CARD_ACCEPTOR_NAME',
	CHANGE_TERMINAL_ID = 'CHANGE_TERMINAL_ID',
	CHANGE_VAT = 'CHANGE_VAT',
	CHANGE_TIME_BLOCK_CHILD_ACCESS = 'CHANGE_TIME_BLOCK_CHILD_ACCESS',
	SET_ID_POS_SYSTEM = 'SET_ID_POS_SYSTEM',
	SET_FILE_ID_FOR_LAUNCHER_SETTINGS = 'SET_FILE_ID_FOR_LAUNCHER_SETTINGS',
	SET_FETCHED_ACQUIRERS = 'SET_FETCHED_ACQUIRERS',
	TOGGLE_USE_MENU_VERSION = 'TOGGLE_USE_MENU_VERSION',
	TOGGLE_USE_CONTENT_VERSION = 'TOGGLE_USE_CONTENT_VERSION',
	CHANGE_RESTAURANT_MENU_VERSION = 'CHANGE_RESTAURANT_MENU_VERSION',
	CHANGE_RESTAURANT_CONTENT_VERSION = 'CHANGE_RESTAURANT_CONTENT_VERSION',
	TOGGLE_USE_TLS_CERTIFICATE = 'TOGGLE_USE_TLS_CERTIFICATE',
	SET_TLS_CERTIFICATE_LEVEL = 'SET_TLS_CERTIFICATE_LEVEL',
	CHANGE_TLS_CERTIFICATE_NAME = 'CHANGE_TLS_CERTIFICATE_NAME',
	SET_TLS_CERTIFICATE_FILE = 'SET_TLS_CERTIFICATE_FILE',
	CHANGE_VAT_ID = 'CHANGE_VAT_ID',
	CHANGE_KM_VAT_ID = 'CHANGE_KM_VAT_ID',
	SET_BPA_SET_ID = 'SET_BPA_SET_ID',
	TOGGLE_APPLICABLE_FOR_VAT = 'TOGGLE_APPLICABLE_FOR_VAT',
	TOGGLE_SEND_DEVICE_UNAVAILABILITY_ALERTS = 'TOGGLE_SEND_DEVICE_UNAVAILABILITY_ALERTS',
	CHANGE_PAYMENT_TYPE_ID = 'CHANGE_PAYMENT_TYPE_ID',
	CHANGE_EXTRA_PAYMENT_TYPE = 'CHANGE_EXTRA_PAYMENT_TYPE',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditRestaurantActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditRestaurantState['needRefetchData'];
	};
}

interface ISetInitialFormData {
	type: EditRestaurantActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IEditRestaurantState['initialFormData'];
	};
}

interface ISetAllData {
	type: EditRestaurantActionTypes.SET_ALL_DATA;
	payload: {
		restaurantId: IEditRestaurantState['restaurantId'];
		name: IEditRestaurantState['name'];
		shortName: IEditRestaurantState['shortName'];
		IDSelectedCustomer: IEditRestaurantState['IDSelectedCustomer'];
		clientType: IEditRestaurantState['clientType'];
		IDSelectedCountry: IEditRestaurantState['IDSelectedCountry'];
		IDSelectedCity: IEditRestaurantState['IDSelectedCity'];
		address: IEditRestaurantState['address'];
		selectedCurrencySymbol: IEditRestaurantState['selectedCurrencySymbol'];
		masterPhoneNumber: IEditRestaurantState['masterPhoneNumber'];
		email: IEditRestaurantState['email'];
		code: IEditRestaurantState['code'];
		additionalApplications: IEditRestaurantState['additionalApplications'];
		vivaWalletIsv: IEditRestaurantState['vivaWalletIsv'];
		supplier: IEditRestaurantState['supplier'];
		isOpenPriceServiceCharge: IEditRestaurantState['isOpenPriceServiceCharge'];
		openPricePercent: IEditRestaurantState['openPricePercent'];
		priceType: IEditRestaurantState['priceType'];
		isUsedCustomerPriceType: IEditRestaurantState['isUsedCustomerPriceType'];
		loyalty: IEditRestaurantState['loyalty'];
		isUsedCustomerTips: IEditRestaurantState['isUsedCustomerTips'];
		tips0: IEditRestaurantState['tips0'];
		tips1: IEditRestaurantState['tips1'];
		tips2: IEditRestaurantState['tips2'];
		tips3: IEditRestaurantState['tips3'];
		defaultTips: IEditRestaurantState['defaultTips'];
		tipsCommissionPercent: IEditRestaurantState['tipsCommissionPercent'];
		tipsCommissionMaxValue: IEditRestaurantState['tipsCommissionMaxValue'];
		isCharityEnabled: IEditRestaurantState['isCharityEnabled'];
		charityName: IEditRestaurantState['charityName'];
		charityLogoPath: IEditRestaurantState['charityLogoPath'];
		charityLogoFileId: IEditRestaurantState['charityLogoFileId'];
		charityAmount0: IEditRestaurantState['charityAmount0'];
		charityAmount1: IEditRestaurantState['charityAmount1'];
		charityAmount2: IEditRestaurantState['charityAmount2'];
		charityAmount3: IEditRestaurantState['charityAmount3'];
		defaultCharityAmountIndex: IEditRestaurantState['defaultCharityAmountIndex'];
		useKmTariff: IEditRestaurantState['useKmTariff'];
		isShowCustomerLoyaltyProgramButtons: IEditRestaurantState['isShowCustomerLoyaltyProgramButtons'];
		isShowLoyaltyProgramButtons: IEditRestaurantState['isShowLoyaltyProgramButtons'];
		baseMcc: IEditRestaurantState['baseMcc'];
		mainMccCardBrand: IEditRestaurantState['mainMccCardBrand'];
		mainMccCardMcc: IEditRestaurantState['mainMccCardMcc'];
		mccCards: IEditRestaurantState['mccCards'];
		useCustomerMcc: IEditRestaurantState['useCustomerMcc'];
		downloadAppAndroidUrl: IEditRestaurantState['downloadAppAndroidUrl'];
		downloadAppIosUrl: IEditRestaurantState['downloadAppIosUrl'];
		IDDefaultLanguage: IEditRestaurantState['IDDefaultLanguage'];
		IDsLanguages: IEditRestaurantState['IDsLanguages'];
		restaurantLanguages: IEditRestaurantState['restaurantLanguages'];
		restrictionQrValue: IEditRestaurantState['restrictionQrValue'];
		usePosPhotos: IEditRestaurantState['usePosPhotos'];
		enableStopListJob: IEditRestaurantState['enableStopListJob'];
		useCustomerStopListSyncInterval: IEditRestaurantState['useCustomerStopListSyncInterval'];
		stopListSyncIntervalMinutes: IEditRestaurantState['stopListSyncIntervalMinutes'];
		updateOfTheLauncher: IEditRestaurantState['updateOfTheLauncher'];
		cardAcceptorId: IEditRestaurantState['cardAcceptorId'];
		cardAcceptorName: IEditRestaurantState['cardAcceptorName'];
		terminalId: IEditRestaurantState['terminalId'];
		vat: IEditRestaurantState['vat'];
		timeBlockChildAccess: IEditRestaurantState['timeBlockChildAccess'];
		IDPosSystem: IEditRestaurantState['IDPosSystem'];
		launcherSettingFilePath: IEditRestaurantState['launcherSettingFilePath'];
		generatedWatchCommandsLink: IEditRestaurantState['generatedWatchCommandsLink'];
		useMenuVersion: IEditRestaurantState['useMenuVersion'];
		useContentVersion: IEditRestaurantState['useContentVersion'];
		customerMenuVersion: IEditRestaurantState['customerMenuVersion'];
		customerContentVersion: IEditRestaurantState['customerContentVersion'];
		restaurantMenuVersion: IEditRestaurantState['restaurantMenuVersion'];
		restaurantContentVersion: IEditRestaurantState['restaurantContentVersion'];
		useTlsCertificate: IEditRestaurantState['useTlsCertificate'];
		tlsCertificateLevel: IEditRestaurantState['tlsCertificateLevel'];
		tlsCertificateName: IEditRestaurantState['tlsCertificateName'];
		tlsCertificateFilePath: IEditRestaurantState['tlsCertificateFilePath'];
		tlsCertificateFileId: IEditRestaurantState['tlsCertificateFileId'];
		vatId: IEditRestaurantState['vatId'];
		kmVatId: IEditRestaurantState['kmVatId'];
		isActiveBpa: IEditRestaurantState['isActiveBpa'];
		bpaSetId: IEditRestaurantState['bpaSetId'];
		isApplicableForVat: IEditRestaurantState['isApplicableForVat'];
		sendDeviceUnavailabilityAlerts: IEditRestaurantState['sendDeviceUnavailabilityAlerts'];
		paymentTypeId: IEditRestaurantState['paymentTypeId'];
		extraPaymentTypes: IEditRestaurantState['extraPaymentTypes'];
	};
}

interface IChangeVisibleForm {
	type: EditRestaurantActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: IEditRestaurantState['visibleForm'];
	};
}

interface IChangeName {
	type: EditRestaurantActionTypes.CHANGE_NAME;
	payload: {
		name: IEditRestaurantState['name'];
	};
}

interface IChangeShortName {
	type: EditRestaurantActionTypes.CHANGE_SHORT_NAME;
	payload: {
		shortName: IEditRestaurantState['shortName'];
	};
}

interface ISetFetchedCustomers {
	type: EditRestaurantActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IEditRestaurantState['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: EditRestaurantActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditRestaurantState['IDSelectedCustomer'];
	};
}

interface ISetClientType {
	type: EditRestaurantActionTypes.SET_CLIENT_TYPE;
	payload: {
		clientType: IEditRestaurantState['clientType'];
	};
}

interface ISetFetchedCountries {
	type: EditRestaurantActionTypes.SET_FETCHED_COUNTRIES;
	payload: {
		fetchedCountries: IEditRestaurantState['fetchedCountries'];
	};
}

interface ISetIDCountry {
	type: EditRestaurantActionTypes.SET_ID_COUNTRY;
	payload: {
		IDSelectedCountry: IEditRestaurantState['IDSelectedCountry'];
	};
}

interface ISetFetchedCities {
	type: EditRestaurantActionTypes.SET_FETCHED_CITIES;
	payload: {
		fetchedCities: IEditRestaurantState['fetchedCities'];
	};
}

interface ISetIDCity {
	type: EditRestaurantActionTypes.SET_ID_CITY;
	payload: {
		IDSelectedCity: IEditRestaurantState['IDSelectedCity'];
	};
}

interface IChangeAddress {
	type: EditRestaurantActionTypes.CHANGE_ADDRESS;
	payload: {
		address: IEditRestaurantState['address'];
	};
}

interface ISetFetchedCurrencies {
	type: EditRestaurantActionTypes.SET_FETCHED_CURRENCIES;
	payload: {
		fetchedCurrencies: IEditRestaurantState['fetchedCurrencies'];
	};
}

interface ISetCurrencySymbol {
	type: EditRestaurantActionTypes.SET_CURRENCY_SYMBOL;
	payload: {
		selectedCurrencySymbol: IEditRestaurantState['selectedCurrencySymbol'];
	};
}

interface IChangeMasterPhoneNumber {
	type: EditRestaurantActionTypes.CHANGE_MASTER_PHONE_NUMBER;
	payload: {
		masterPhoneNumber: IEditRestaurantState['masterPhoneNumber'];
	};
}

interface IChangeEmail {
	type: EditRestaurantActionTypes.CHANGE_EMAIL;
	payload: {
		email: IEditRestaurantState['email'];
	};
}

interface IChangeCode {
	type: EditRestaurantActionTypes.CHANGE_CODE;
	payload: {
		code: IEditRestaurantState['code'];
	};
}

interface ISetAdditionalApplications {
	type: EditRestaurantActionTypes.SET_ADDITIONAL_APPLICATIONS;
	payload: {
		additionalApplications: TAdditionalApplications[];
		vivaWalletIsv: IEditRestaurantState['vivaWalletIsv'];
	};
}

interface IChangeVivaWalletIsv {
	type: EditRestaurantActionTypes.CHANGE_VIVA_WALLET_ISV;
	payload: {
		vivaWalletIsv: IEditRestaurantState['vivaWalletIsv'];
	};
}

interface IChangeSupplier {
	type: EditRestaurantActionTypes.CHANGE_SUPPLIER;
	payload: {
		supplier: IEditRestaurantState['supplier'];
	};
}

interface IToggleIsOpenPriceServiceCharge {
	type: EditRestaurantActionTypes.TOGGLE_IS_OPEN_PRICE_PERCENT;
}

interface IChangeOpenPricePercent {
	type: EditRestaurantActionTypes.CHANGE_OPEN_PRICE_PERCENT;
	payload: {
		openPricePercent: IEditRestaurantState['openPricePercent'];
	};
}

interface IChangePriceType {
	type: EditRestaurantActionTypes.CHANGE_PRICE_TYPE;
	payload: {
		priceType: IEditRestaurantState['priceType'];
	};
}

interface IToggleIsUsedCustomerPriceType {
	type: EditRestaurantActionTypes.TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE;
	payload: {
		isUsedCustomerPriceType: IEditRestaurantState['isUsedCustomerPriceType'];
		priceType: IEditRestaurantState['priceType'];
	};
}

interface IChangeLoyalty {
	type: EditRestaurantActionTypes.CHANGE_LOYALTY;
	payload: {
		loyalty: IEditRestaurantState['loyalty'];
	};
}

interface IToggleIsUsedCustomerTips {
	type: EditRestaurantActionTypes.TOGGLE_IS_USED_CUSTOMER_TIPS;
	payload: {
		isUsedCustomerTips: IEditRestaurantState['isUsedCustomerTips'];
		tips0: IEditRestaurantState['tips0'];
		tips1: IEditRestaurantState['tips1'];
		tips2: IEditRestaurantState['tips2'];
		tips3: IEditRestaurantState['tips3'];
		defaultTips: IEditRestaurantState['defaultTips'];
	};
}

interface ISetTips0 {
	type: EditRestaurantActionTypes.SET_TIPS_0;
	payload: {
		tips0: IEditRestaurantState['tips0'];
	};
}

interface ISetTips1 {
	type: EditRestaurantActionTypes.SET_TIPS_1;
	payload: {
		tips1: IEditRestaurantState['tips1'];
	};
}

interface ISetTips2 {
	type: EditRestaurantActionTypes.SET_TIPS_2;
	payload: {
		tips2: IEditRestaurantState['tips2'];
	};
}

interface ISetTips3 {
	type: EditRestaurantActionTypes.SET_TIPS_3;
	payload: {
		tips3: IEditRestaurantState['tips3'];
	};
}

interface ISetDefaultTips {
	type: EditRestaurantActionTypes.SET_DEFAULT_TIPS;
	payload: {
		defaultTips: IEditRestaurantState['defaultTips'];
	};
}

interface ISetTipsCommissionPercent {
	type: EditRestaurantActionTypes.SET_TIPS_COMMISSION_PERCENT;
	payload: {
		tipsCommissionPercent: IEditRestaurantState['tipsCommissionPercent'];
		tipsCommissionMaxValue: IEditRestaurantState['tipsCommissionMaxValue'];
	};
}

interface ISetTipsCommissionMaxValue {
	type: EditRestaurantActionTypes.SET_TIPS_COMMISSION_MAX_VALUE;
	payload: {
		tipsCommissionMaxValue: IEditRestaurantState['tipsCommissionMaxValue'];
	};
}

interface IToggleIsCharityEnabled {
	type: EditRestaurantActionTypes.TOGGLE_IS_CHARITY_ENABLED;
}

interface IChangeCharityName {
	type: EditRestaurantActionTypes.CHANGE_CHARITY_NAME;
	payload: {
		charityName: IEditRestaurantState['charityName'];
	};
}

interface ISetCharityLogoFile {
	type: EditRestaurantActionTypes.SET_CHARITY_LOGO_FILE;
	payload: {
		charityLogoFileId: IEditRestaurantState['charityLogoFileId'];
	};
}

interface ISetCharityAmount0 {
	type: EditRestaurantActionTypes.SET_CHARITY_AMOUNT_0;
	payload: {
		charityAmount0: IEditRestaurantState['charityAmount0'];
		defaultCharityAmountIndex: IEditRestaurantState['defaultCharityAmountIndex'];
	};
}

interface ISetCharityAmount1 {
	type: EditRestaurantActionTypes.SET_CHARITY_AMOUNT_1;
	payload: {
		charityAmount1: IEditRestaurantState['charityAmount1'];
		defaultCharityAmountIndex: IEditRestaurantState['defaultCharityAmountIndex'];
	};
}

interface ISetCharityAmount2 {
	type: EditRestaurantActionTypes.SET_CHARITY_AMOUNT_2;
	payload: {
		charityAmount2: IEditRestaurantState['charityAmount2'];
		defaultCharityAmountIndex: IEditRestaurantState['defaultCharityAmountIndex'];
	};
}

interface ISetCharityAmount3 {
	type: EditRestaurantActionTypes.SET_CHARITY_AMOUNT_3;
	payload: {
		charityAmount3: IEditRestaurantState['charityAmount3'];
		defaultCharityAmountIndex: IEditRestaurantState['defaultCharityAmountIndex'];
	};
}

interface ISetDefaultCharityAmountIndex {
	type: EditRestaurantActionTypes.SET_DEFAULT_CHARITY_AMOUNT_INDEX;
	payload: {
		defaultCharityAmountIndex: IEditRestaurantState['defaultCharityAmountIndex'];
	};
}

interface IToggleUseKmTariff {
	type: EditRestaurantActionTypes.TOGGLE_USE_KM_TARIFF;
}

interface IToggleShowLoyaltyProgramButtons {
	type: EditRestaurantActionTypes.TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS;
}

interface IChangeBaseMcc {
	type: EditRestaurantActionTypes.CHANGE_BASE_MCC;
	payload: {
		baseMcc: IEditRestaurantState['baseMcc'];
	};
}

interface IAddMccCard {
	type: EditRestaurantActionTypes.ADD_MCC_CARD;
	payload: {
		mccCards: IEditRestaurantState['mccCards'];
	};
}

interface IDeleteMccCard {
	type: EditRestaurantActionTypes.DELETE_MCC_CARD;
	payload: {
		mccCards: IEditRestaurantState['mccCards'];
	};
}

interface IChangeMainMccCardBrand {
	type: EditRestaurantActionTypes.CHANGE_MAIN_MCC_CARD_BRAND;
	payload: {
		mainMccCardBrand: IEditRestaurantState['mainMccCardBrand'];
	};
}

interface IChangeMccCardBrand {
	type: EditRestaurantActionTypes.CHANGE_MCC_CARD_BRAND;
	payload: {
		mccCards: IEditRestaurantState['mccCards'];
	};
}

interface IChangeMainMccCardMcc {
	type: EditRestaurantActionTypes.CHANGE_MAIN_MCC_CARD_MCC;
	payload: {
		mainMccCardMcc: IEditRestaurantState['mainMccCardMcc'];
	};
}

interface IChangeMccCardMcc {
	type: EditRestaurantActionTypes.CHANGE_MCC_CARD_MCC;
	payload: {
		mccCards: IEditRestaurantState['mccCards'];
	};
}

interface IToggleUseCustomerMcc {
	type: EditRestaurantActionTypes.TOGGLE_USE_CUSTOMER_MCC;
}

interface IChangeDownloadAppAndroidUrl {
	type: EditRestaurantActionTypes.CHANGE_DOWNLOAD_APP_ANDROID_URL;
	payload: {
		downloadAppAndroidUrl: IEditRestaurantState['downloadAppAndroidUrl'];
	};
}

interface IChangeDownloadAppIosUrl {
	type: EditRestaurantActionTypes.CHANGE_DOWNLOAD_APP_IOS_URL;
	payload: {
		downloadAppIosUrl: IEditRestaurantState['downloadAppIosUrl'];
	};
}

interface ISetFetchedLanguages {
	type: EditRestaurantActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		fetchedLanguages: IEditRestaurantState['fetchedLanguages'];
	};
}

interface ISetIDDefaultLanguage {
	type: EditRestaurantActionTypes.SET_ID_DEFAULT_LANGUAGE;
	payload: {
		IDDefaultLanguage: IEditRestaurantState['IDDefaultLanguage'];
	};
}

interface ISetIDsLanguages {
	type: EditRestaurantActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsLanguages: IEditRestaurantState['IDsLanguages'];
	};
}

interface IChangeRestrictionQrValue {
	type: EditRestaurantActionTypes.CHANGE_RESTRICTION_QR_VALUE;
	payload: {
		restrictionQrValue: IEditRestaurantState['restrictionQrValue'];
	};
}

interface IToggleUsePosPhotos {
	type: EditRestaurantActionTypes.TOGGLE_USE_POS_PHOTOS;
}

interface IToggleStopListJob {
	type: EditRestaurantActionTypes.TOGGLE_STOP_LIST_JOB;
}

interface IToggleUseCustomerStopListSyncInterval {
	type: EditRestaurantActionTypes.TOGGLE_USE_CUSTOMER_STOP_LIST_SYNC_INTERVAL;
}

interface IChangeStopListSyncIntervalMinutes {
	type: EditRestaurantActionTypes.CHANGE_STOP_LIST_SYNC_INTERVAL_MINUTES;
	payload: {
		stopListSyncIntervalMinutes: IEditRestaurantState['stopListSyncIntervalMinutes'];
	};
}

interface IToggleUpdateOfTheLauncher {
	type: EditRestaurantActionTypes.TOGGLE_UPDATE_OF_THE_LAUNCHER;
}

interface IChangeCardAcceptorIdt {
	type: EditRestaurantActionTypes.CHANGE_CARD_ACCEPTOR_ID;
	payload: {
		cardAcceptorId: IEditRestaurantState['cardAcceptorId'];
	};
}

interface IChangeCardAcceptorName {
	type: EditRestaurantActionTypes.CHANGE_CARD_ACCEPTOR_NAME;
	payload: {
		cardAcceptorName: IEditRestaurantState['cardAcceptorName'];
	};
}

interface IChangeTerminalId {
	type: EditRestaurantActionTypes.CHANGE_TERMINAL_ID;
	payload: {
		terminalId: IEditRestaurantState['terminalId'];
	};
}

interface IChangeVat {
	type: EditRestaurantActionTypes.CHANGE_VAT;
	payload: {
		vat: IEditRestaurantState['vat'];
	};
}

interface IChangeTimeBlockChildAccess {
	type: EditRestaurantActionTypes.CHANGE_TIME_BLOCK_CHILD_ACCESS;
	payload: {
		timeBlockChildAccess: IEditRestaurantState['timeBlockChildAccess'];
	};
}

interface ISetIDPosSystem {
	type: EditRestaurantActionTypes.SET_ID_POS_SYSTEM;
	payload: {
		IDPosSystem: IEditRestaurantState['IDPosSystem'];
	};
}

interface ISetLauncherSettingsFile {
	type: EditRestaurantActionTypes.SET_FILE_ID_FOR_LAUNCHER_SETTINGS;
	payload: {
		fileIdForLauncherSettings: IEditRestaurantState['fileIdForLauncherSettings'];
	};
}

interface ISetFetchedAcquirers {
	type: EditRestaurantActionTypes.SET_FETCHED_ACQUIRERS;
	payload: {
		fetchedAcquirers: IEditRestaurantState['fetchedAcquirers'];
	};
}

interface IToggleUseMenuVersion {
	type: EditRestaurantActionTypes.TOGGLE_USE_MENU_VERSION;
	payload: {
		useMenuVersion: IEditRestaurantState['useMenuVersion'];
		restaurantMenuVersion: IEditRestaurantState['restaurantMenuVersion'];
	};
}

interface IToggleUseContentVersion {
	type: EditRestaurantActionTypes.TOGGLE_USE_CONTENT_VERSION;
	payload: {
		useContentVersion: IEditRestaurantState['useContentVersion'];
		restaurantContentVersion: IEditRestaurantState['restaurantContentVersion'];
	};
}

interface IChangeRestaurantMenuVersion {
	type: EditRestaurantActionTypes.CHANGE_RESTAURANT_MENU_VERSION;
	payload: {
		restaurantMenuVersion: IEditRestaurantState['restaurantMenuVersion'];
	};
}

interface IChangeRestaurantContentVersion {
	type: EditRestaurantActionTypes.CHANGE_RESTAURANT_CONTENT_VERSION;
	payload: {
		restaurantContentVersion: IEditRestaurantState['restaurantContentVersion'];
	};
}

interface IToggleUseTLSCertificate {
	type: EditRestaurantActionTypes.TOGGLE_USE_TLS_CERTIFICATE;
}

interface ISetTlsCertificateLevel {
	type: EditRestaurantActionTypes.SET_TLS_CERTIFICATE_LEVEL;
	payload: {
		tlsCertificateLevel: IEditRestaurantState['tlsCertificateLevel'];
	};
}

interface IChangeTlsCertificateName {
	type: EditRestaurantActionTypes.CHANGE_TLS_CERTIFICATE_NAME;
	payload: {
		tlsCertificateName: IEditRestaurantState['tlsCertificateName'];
	};
}

interface ISetTlsCertificateFile {
	type: EditRestaurantActionTypes.SET_TLS_CERTIFICATE_FILE;
	payload: {
		tlsCertificateFileId: IEditRestaurantState['tlsCertificateFileId'];
		tlsCertificateFileHash: IEditRestaurantState['tlsCertificateFileHash'];
	};
}

interface IChangeVatId {
	type: EditRestaurantActionTypes.CHANGE_VAT_ID;
	payload: {
		vatId: IEditRestaurantState['vatId'];
	};
}

interface IChangeKmVatId {
	type: EditRestaurantActionTypes.CHANGE_KM_VAT_ID;
	payload: {
		kmVatId: IEditRestaurantState['kmVatId'];
	};
}

interface ISetBpaSetId {
	type: EditRestaurantActionTypes.SET_BPA_SET_ID;
	payload: {
		bpaSetId: IEditRestaurantState['bpaSetId'];
	};
}

interface IToggleApplicableForVat {
	type: EditRestaurantActionTypes.TOGGLE_APPLICABLE_FOR_VAT;
}

interface IToggleSendDeviceUnavailabilityAlerts {
	type: EditRestaurantActionTypes.TOGGLE_SEND_DEVICE_UNAVAILABILITY_ALERTS;
}

interface IChangePaymentTypeId {
	type: EditRestaurantActionTypes.CHANGE_PAYMENT_TYPE_ID;
	payload: {
		paymentTypeId: IEditRestaurantState['paymentTypeId'];
	};
}
interface IChangeExtraPaymentTypes {
	type: EditRestaurantActionTypes.CHANGE_EXTRA_PAYMENT_TYPE;
	payload: {
		extraPaymentTypes: IEditRestaurantState['extraPaymentTypes'];
	};
}

interface ISetDataForSubmit {
	type: EditRestaurantActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditRestaurantState['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditRestaurantActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditRestaurantState['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: EditRestaurantActionTypes.RESET_FIELDS;
}

export type TEditRestaurantAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| IChangeName
	| IChangeShortName
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetClientType
	| ISetFetchedCountries
	| ISetIDCountry
	| ISetFetchedCities
	| ISetIDCity
	| IChangeAddress
	| ISetFetchedCurrencies
	| ISetCurrencySymbol
	| IChangeMasterPhoneNumber
	| IChangeEmail
	| IChangeCode
	| ISetAdditionalApplications
	| IChangeVivaWalletIsv
	| IChangeSupplier
	| IToggleIsOpenPriceServiceCharge
	| IChangeOpenPricePercent
	| IChangePriceType
	| IToggleIsUsedCustomerPriceType
	| IChangeLoyalty
	| IToggleIsUsedCustomerTips
	| ISetTips0
	| ISetTips1
	| ISetTips2
	| ISetTips3
	| ISetDefaultTips
	| ISetTipsCommissionPercent
	| ISetTipsCommissionMaxValue
	| IToggleIsCharityEnabled
	| IChangeCharityName
	| ISetCharityLogoFile
	| ISetCharityAmount0
	| ISetCharityAmount1
	| ISetCharityAmount2
	| ISetCharityAmount3
	| ISetDefaultCharityAmountIndex
	| IToggleUseKmTariff
	| IToggleShowLoyaltyProgramButtons
	| IChangeBaseMcc
	| IAddMccCard
	| IDeleteMccCard
	| IChangeMainMccCardBrand
	| IChangeMccCardBrand
	| IChangeMainMccCardMcc
	| IChangeMccCardMcc
	| IToggleUseCustomerMcc
	| IChangeDownloadAppAndroidUrl
	| IChangeDownloadAppIosUrl
	| ISetFetchedLanguages
	| ISetIDDefaultLanguage
	| ISetIDsLanguages
	| IChangeRestrictionQrValue
	| IToggleUsePosPhotos
	| IToggleStopListJob
	| IToggleUseCustomerStopListSyncInterval
	| IChangeStopListSyncIntervalMinutes
	| IToggleUpdateOfTheLauncher
	| IChangeCardAcceptorIdt
	| IChangeCardAcceptorName
	| IChangeTerminalId
	| IChangeVat
	| IChangeTimeBlockChildAccess
	| ISetIDPosSystem
	| ISetLauncherSettingsFile
	| ISetFetchedAcquirers
	| IToggleUseMenuVersion
	| IToggleUseContentVersion
	| IChangeRestaurantMenuVersion
	| IChangeRestaurantContentVersion
	| IToggleUseTLSCertificate
	| ISetTlsCertificateLevel
	| IChangeTlsCertificateName
	| ISetTlsCertificateFile
	| IChangeVatId
	| IChangeKmVatId
	| ISetBpaSetId
	| IToggleApplicableForVat
	| IToggleSendDeviceUnavailabilityAlerts
	| IChangePaymentTypeId
	| IChangeExtraPaymentTypes
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
